
import React, { useState, useRef, useEffect, Fragment } from "react";
import "./Report.css";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import CustomLineChart from "../../components/CustomLineChart";
import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, validateNestedData } from "../../../exportreport/utils"
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";
import UserProfile from "../../components/UserProfile";
import ArrowIcon from "./ArrowIcon";
import BackSide from "./BackSide"
const PropertyTypePage = (props) => {
    const { name, title, type, reportData, searchTags, summarizeGeographies, priorYearPeriodName,logo, currentPeriodName, customDate, color, user, formValues, AiResponse } = props;
	const { dateOptions, theme, style ,branding} = customDate;
    const hasLocation = searchTags && searchTags.length>0;
    const isPos = (validateNestedData(
        reportData,
        `facets.${type.key}.contract_signed.current_period.count`
      ) &&
      validateNestedData(
        reportData,
        `facets.${type.key}.contract_signed.prior_year_period.count`
      )
        ? reportData.facets[type.key].contract_signed.current_period.count >= reportData.facets[type.key].contract_signed.prior_year_period.count
        : true);
      const chartData =  validateNestedData(
        reportData,
        `facets.${type.key}.contract_signed.chart`
      )
        ? reportData.facets[type.key].contract_signed.chart.buckets.slice(reportData.facets[type.key].contract_signed.chart.buckets.length - 13, reportData.facets[type.key].contract_signed.chart.buckets.length).map(item => ({year : formatDateRange(null, null, item.val), price: item.ppsf && item.ppsf.avg ? Math.round(item.ppsf.avg) : 0})) : [];
        return (
          <>
            <div
              className="postcard-container page-section"
            >
              <section className="postcard-branding">
                {branding && branding && branding === "mylogo" && logo ? (
                  <div className="brand-logo">
                    <div>
                      <img
                        className="header-logo"
                        src={logo}
                        style={{ maxHeight: 70 }}
                      />
                    </div>
                  </div>
                ) : branding && branding && branding === "marketproof" ? (
                  <div className="brand-logo">
                    <div>
                      <img
                        src="https://marketproof-hosting.s3.amazonaws.com/logos/marketproof-logo-horizontal-transparent-background.png"
                        style={{ maxHeight: 70 }}
                      />
                    </div>
                  </div>
                ) : null}
                <h3 className="primary-cta editable">Unlock Your Home's Value!</h3>
              </section>
              
              <section className="postcard-section" >
                <h3 className="heading-location editable">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}</h3>
                <div className="postcard-heading editable">{type.name}</div>
                <div className="sub-header-wrapper bold">
                  <span className="editable">{type.title}</span>
                  <span className="editable">{currentPeriodName}</span>
                </div>            
                <div className="content-wrapper">
                  <h3>{(validateNestedData(
                    reportData,
                    `facets.${type.key}.contract_signed.current_period.count`
                  ) &&
                  validateNestedData(
                    reportData,
                    `facets.${type.key}.contract_signed.prior_year_period.count`
                  )
                    ? _formatNumber(
                        reportData.facets[type.key].contract_signed.current_period.count
                      )
                    : "--")}</h3>
                  <ArrowIcon isPositive={isPos} />
                  <div className="grid-layout">
                    <div  className="row">
                      <div>YoY Chg</div>
                      <div>{(validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.current_period.count`
                      ) &&
                      validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.prior_year_period.count`
                      )
                        ? `${isPos ? "+" : ""}${percentageChange(
                            reportData.facets[type.key].contract_signed.current_period
                              .count,
                            reportData.facets[type.key].contract_signed.prior_year_period
                              .count
                          )}%`
                        : "--")}</div>
                    </div>
                    <div  className="row">
                      <div>Avg Price</div>
                      <div>{(validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.current_period.avg_price`
                      ) &&
                      validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.prior_year_period.avg_price`
                      )
                        ? `${_formatPrice(
                            reportData.facets[type.key].contract_signed.current_period
                              .avg_price)}`
                        : "--")}</div>
                    </div>
                    <div  className="row">
                      <div>Avg PPSF</div>
                      <div>{(validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.current_period.ppsf.avg`
                      ) &&
                      validateNestedData(
                        reportData,
                        `facets.${type.key}.contract_signed.prior_year_period.ppsf.avg`
                      )
                        ? `$${_formatNumber(
                            reportData.facets[type.key].contract_signed.current_period
                              .ppsf.avg)}`
                        : "--")}</div>
                    </div>
                   
                  </div>
                </div>
              <div className="postcard-chart">
              <CustomLineChart
                  theme={theme}
                  data={chartData}
                  axisSize={16}
                  isWeekly={dateOptions.gap}
                  XAxisFont={16}
                  YAxisFont={16}
                />
              </div>
              </section>
            </div>
            <BackSide userDetails={user} aiResponse={AiResponse} formValues={formValues}/>
          </>
        );
}


export default PropertyTypePage